(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfFocusMe', [
    '$timeout', function($timeout) {
      return {
        link: function(scope, element, attrs) {
          return scope.$watch(attrs.mfFocusMe, (function(_this) {
            return function(value) {
              return $timeout(function() {
                return element[0].focus();
              });
            };
          })(this));
        }
      };
    }
  ]);

}).call(this);
